/**
 * ReportFinancialSeed entity class
 */
import moment from 'moment/moment'

/**
 * ReportFinancialSeedFactory
 * returns ReportFinancialSeed entity class
 *
 * @class ReportFinancialSeedFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.ReportFinancialSeed} class
 *
 * @ngdoc factory
 * @name mwApp.factory:ReportFinancialSeedFactory
 */
/* @ngInject */
export default function ReportFinancialSeedFactory ($http, $injector, Entity, onOffMixin, alertLiteSvc) {
  /* === ReportFinancialSeed class === */

  /**
   * ReportFinancialSeed model
   *
   * @class ReportFinancialSeed
   * @classdesc ReportFinancialSeed model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @mixes models.onOffMixin
   * @return {models.ReportFinancialSeed} ReportFinancialSeed entity
   */
  function ReportFinancialSeed () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  ReportFinancialSeed.prototype = Object.create(Entity.prototype)
  ReportFinancialSeed.prototype.constructor = ReportFinancialSeed

  /* === User instance methods & fields === */

  Object.assign(ReportFinancialSeed.prototype, {

    /**
     * instance fields
     *
     * @memberof models.ReportFinancialSeed#
     * @type {Object}finanmodel
     */
    _fields: {
      autoPay: false,
      // createdBy: String,
      fields: [String],
      firstActivation: false,
      from: moment,
      to: moment,
      organizations: ['Network'],
      paymentSystemTypes: [String],
      paymentMethodTypes: [String],
      purchaseItemCategories: [String],
      purchaseItemStatuses: [String],
      // purchaseStatus: 'PAID',
      periodCount: 0,
      periodType: String,
      reportId: Number,
      reportName: String,
      // reportType: [String],
      subscriptionsFilter: {
        names: [String],
        dailySubscriptionLength: {
          from: moment,
          to: moment
        },
        monthlySubscriptionLength: {
          from: moment,
          to: moment
        }
      },
      users: [String],
      convertedAfterTrialDays: Number,
      withoutTrial: false,
      $convertedAfterTrialDays: false,
      $bySubscription: 'Plans'
    },

    /**
     * Split amounts by types to auxiliary fields and sort them
     *
     * @memberof models.ReportFinancialSeed#
     * @override
     */
    _prepare: function () {
      if (!this.subscriptionsFilter) { this.subscriptionsFilter = {} }
      if (!this.subscriptionsFilter.dailySubscriptionLength) {
        this.subscriptionsFilter.dailySubscriptionLength = {}
      }
      if (!this.subscriptionsFilter.monthlySubscriptionLength) {
        this.subscriptionsFilter.monthlySubscriptionLength = {}
      }
    },

    /**
     * Get underlying object
     *
     * @memberof models.ReportFinancialSeed#
     * @return {Object} new underlying object as plain object
     * @override
     */
    _object: function () {
      const ret = Entity.prototype._object.apply(this, arguments)

      if (ret.periodType === 'CUSTOM') {
        const utcIso = 'YYYY-MM-DD[T]HH:mm:ss[Z]'

        ret.from = moment(this.from).startOf('day').utc().format(utcIso)
        ret.to = moment(this.to).endOf('day').utc().format(utcIso)
      }

      return ret
    },

    /**
     * url template
     *
     * @memberof models.ReportFinancialSeed#
     * @type {String}
     */
    _urlTemplate: 'api/report/financial/{{::reportId}}',

    /**
     * public url template
     *
     * @memberof models.ReportFinancialSeed#
     * @type {String}
     */
    _publicUrlTemplate: '/report/financial/{{::reportId}}'

  }, onOffMixin)

  /* === ReportFinancialSeed static methods & fields === */

  ReportFinancialSeed.getSubscriptions = function () {
    return $http.get('/report/financial/extra')
      .data()
      .then((response) => response.payload)
      .catch(rejection => alertLiteSvc.alertError(rejection))
  }

  /**
   * Search shows by param
   *
   * @param {String} url
   * @param {Object} params
   * @returns {Promise} promise
   */
  ReportFinancialSeed.search = function (url, params) {
    return $http.post(url, { ...params })
      .data()
      .then((response) => response.payload)
      .catch(rejection => alertLiteSvc.alertError(rejection))
  }

  ReportFinancialSeed.extra = {
    subscriptions: [{ id: Number, name: String }]
  }

  // copy all static methods from Entity class
  Object.assign(ReportFinancialSeed, Entity)
  ReportFinancialSeed._name = 'Financial Report'
  ReportFinancialSeed.init()

  // permissions
  // ReportFinancialSeed.access = {
  //   view: 'viewReport',
  //   create: 'createReport',
  //   delete: 'deleteReport'
  // }

  return ReportFinancialSeed
}
